import Vue from 'vue'
import Router from 'vue-router';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'main_page',
            component: () =>
                import ('./views/Main'),
        },
        {
            path: '/login',
            name: 'login_page',
            component: () =>
                import ('./views/Login')
        },
        {
            path: '/register',
            name: 'register_page',
            component: () =>
                import ('./views/Registration')
        },
        {
            path: '/library',
            name: 'documents_library',
            component: () =>
                import ('./views/DocumentsLibrary'),
            meta: { requiredAuth: true }
        },
        {
            path: '/account',
            name: 'account_page',
            component: () =>
                import ('./views/Account'),
            meta: { requiredAuth: true }
        },
        {
            path: '/library2',
            name: 'documents_library_blocks',
            component: () =>
                import ('./views/DocumentsLibraryBlocks'),
            meta: { requiredAuth: true }
        },
        {
            path: '/tn',
            name: 'tmp_navigation',
            component: () =>
                import ('./TmpNav'),
            meta: { requiredAuth: true }
        },

        {
            path: '/council',
            name: 'council_members',
            component: () =>
                import ('./views/Council'),
            meta: { requiredAuth: true }
        },
        {
            path: '/gallery',
            name: 'gallery',
            component: () =>
                import ('./views/Gallery'),
            meta: { requiredAuth: true }
        },
        {
            path: '/tableContents',
            name: 'tableContents',
            component: () =>
                import ('./views/TableOfContents'),
            meta: { requiredAuth: true }
        },
        {
            path: '/events',
            name: 'events',
            component: () =>
                import ('./views/Events'),
            meta: { requiredAuth: true }
        },
        {
            path: '/contacts',
            name: 'Contacts',
            component: () =>
                import ('./views/Contacts')
        },
        {
            path: '/404',
            alias: '*',
            name: 'notFound',
            component: () =>
                import ('../src/components/layout/NotFound')
        },
    ]
});

// Authenticating the routes:

router.beforeEach((to, from, next) => {
    if (to.meta.requiredAuth) {
        if (!localStorage.getItem('token')) {
            next({ name: 'login_page' });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;